// src/features/wf1/api.js
import api from "../../api/axios";

/* ======= Apoio (listas) ======= */
export const wf1Api = {
  getGerencias: () => api.get("/equipamentos/gerencias"),
  getCoordenadores: (gerencia, options = {}) =>
    api.get("/equipamentos/coordenadores", {
      params: {
        gerencia_nome: gerencia,
        ...(options.detalhado ? { detalhado: 1 } : {}),
      },
    }),
  getSubs: (coordenador) =>
    api.get("/equipamentos/subs", { params: { coordenador_nome: coordenador } }),
  getAtividades: () => api.get("/atividades/nomes"),
  getAtivos:     () => api.get("/ativos/nomes"),
  getSBsDistinct: () => api.get("/sb-origem-encerramento/distinct"),

  /* ======= Validações KM/SB ======= */
  validarKm: (sub, kmInicio, kmFinal) =>
    api.get("/equipamentos/validar-km", { params: { subdivisao_id: sub, kmInicio, kmFinal } }),
  sbPorKm: (sub, kmInicio, kmFinal) =>
    api.get("/equipamentos/sb-km", { params: { subdivisao_id: sub, kmInicio, kmFinal } }),

  /* ======= W1 (create/list) ======= */
  createW1: (payload, idempotencyKey) =>
    api.post("/wf-1/create", payload, {
      headers: idempotencyKey ? { "x-idempotency-key": idempotencyKey } : undefined,
    }),
  listW1: (params) => api.get("/wf-1/listar", { params }),
};

export function genIdempotencyKey() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "idem-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}
